'use strict';

module.exports = require('react').addons.shallowCompare;



//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.33/react-addons-shallow-compare.js
// module id = 472
// module chunks = 171